







































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import Number from "@/shared/filters/Number";

import { LiftService } from "@/services/Lift.Service.ts";
import { ElSelect } from "element-ui/types/select";
import { KyotenData } from "@/models/KyotenData";

export interface LiftData {
  id?: number;
  sknUketsukeExtendsId?: number;
  sknWorkProgressStateNm?: string;
  kkUketsukeNm?: string;
  srModelNm?: string;
  ukTantoushaNm?: string;
  sknFrontTantoushaNm?: string;
  progressNm?: string;
  plateNm?: string;
}

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString
  }
})
export default class LiftUse extends Vue {
  @Prop({ default: "" })
  title: string;
  public liftService = new LiftService();
  public liftDataList: LiftData[] = [];
  public kyotenDataList: KyotenData[] = [];
  private loading: boolean = false;
  public form: any = {
    kyotenSelected: ""
  };

  constructor() {
    super();
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public async getLiftList(kyotenCd: string | null) {
    const response = await this.liftService.getLifts(kyotenCd);
    if (response) {
      this.$set(this, "liftDataList", response);
    } else {
      this.$set(this, "liftDataList", []);
    }
  }

  public async getKyotenDataList() {
    const response = await this.liftService.getKyotens();
    if (response) {
      this.$set(this, "kyotenDataList", response);
    }
  }

  public async onDelItem(id: number) {
    this.loading = true;
    const response = await this.liftService.deleteLift(id);
    if (response) {
      this.getLiftList(this.form.kyotenSelected);
    }
    this.delay(1000);
  }

  public async selectKyoten() {
    this.loading = true;
    const data = this.kyotenDataList.filter(
      (e: any) => e.staffCd === this.form.kyotenSelected
    );
    this.getLiftList(this.form.kyotenSelected);
    this.delay(1000);
  }

  private created() {
    this.getKyotenDataList();
    this.getLiftList(localStorage.getItem("kyotenCd"));
    this.form.kyotenSelected = localStorage.getItem("kyotenCd");
  }

  private mounted() {}
}
